var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Alert icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.10396 7.04348H5.13004V13.6H2.10396C1.9702 13.6 1.84191 13.5469 1.74733 13.4523C1.65275 13.3577 1.59961 13.2294 1.59961 13.0957V7.54783C1.59961 7.41407 1.65275 7.28578 1.74733 7.1912C1.84191 7.09662 1.9702 7.04348 2.10396 7.04348V7.04348Z",
    stroke: "#106B4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.13086 7.04348L7.6526 2C7.91753 2 8.17986 2.05218 8.42462 2.15356C8.66938 2.25495 8.89178 2.40355 9.07911 2.59088C9.26644 2.77821 9.41504 3.00061 9.51643 3.24537C9.61781 3.49013 9.66999 3.75246 9.66999 4.01739V5.53044H13.5708C13.7139 5.53044 13.8553 5.56085 13.9856 5.61967C14.116 5.67848 14.2324 5.76435 14.327 5.87157C14.4217 5.9788 14.4925 6.10493 14.5346 6.24159C14.5768 6.37825 14.5895 6.52232 14.5717 6.66424L13.8152 12.7164C13.7847 12.9604 13.6662 13.1848 13.4819 13.3475C13.2976 13.5102 13.0602 13.6 12.8143 13.6H5.13086",
    stroke: "#106B4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsup);
export default __webpack_public_path__ + "static/media/thumbsup.7bf5edbaf83306b2eec76d92d498741e.svg";
export { ForwardRef as ReactComponent };